import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProductAuth = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 63,
	height: 62,
	viewBox: "0 0 63 62",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Auth" }),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_14030_19441)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M36.4219 26.1562C36.4219 23.4801 34.2193 21.3125 31.5 21.3125C28.7807 21.3125 26.5781 23.4801 26.5781 26.1562",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M44.2969 26.1562C44.2969 19.2006 38.5678 13.5625 31.5 13.5625C24.4322 13.5625 18.7031 19.2006 18.7031 26.1562",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M55.125 26.1563V23.25C55.125 22.1796 54.244 21.3125 53.1563 21.3125H50.966C50.1416 21.3125 49.396 20.8064 49.1228 20.0411C48.3501 17.8759 47.1836 15.8924 45.6972 14.1825C45.1607 13.565 45.0868 12.681 45.5003 11.9762L46.5905 10.1211C47.1344 9.19347 46.812 8.00918 45.8694 7.47394L40.7556 4.56769C39.8131 4.03246 38.6097 4.34972 38.0658 5.2773L36.9707 7.14214C36.5523 7.85418 35.7254 8.22472 34.9035 8.07215C33.801 7.86629 32.664 7.75004 31.5 7.75004C30.336 7.75004 29.199 7.86629 28.0965 8.07215C27.2746 8.22715 26.4477 7.85418 26.0294 7.14214L24.9342 5.2773C24.3904 4.34972 23.187 4.03246 22.2444 4.56769L17.1306 7.47394C16.1881 8.00918 15.8657 9.19347 16.4096 10.1211L17.4973 11.9762C17.9107 12.6786 17.8369 13.565 17.3004 14.1825C15.814 15.8924 14.6475 17.8735 13.8748 20.0411C13.6016 20.8064 12.8584 21.3125 12.0315 21.3125H9.84131C8.75357 21.3125 7.87256 22.1796 7.87256 23.25V26.1563",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.5 36.8125V30.0312",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.8125 36.8125V30.0312H51.1875V36.8125",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.7031 52.3125V55.2188C18.7031 56.2892 17.8221 57.1562 16.7344 57.1562H6.89062C5.80289 57.1562 4.92188 56.2892 4.92188 55.2188V52.3125C4.92188 50.1716 6.68391 48.4375 8.85938 48.4375H14.7656C16.9411 48.4375 18.7031 50.1716 18.7031 52.3125Z",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.8125 48.4375C13.9871 48.4375 15.75 46.7026 15.75 44.5625C15.75 42.4224 13.9871 40.6875 11.8125 40.6875C9.63788 40.6875 7.875 42.4224 7.875 44.5625C7.875 46.7026 9.63788 48.4375 11.8125 48.4375Z",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M38.3906 52.3125V55.2188C38.3906 56.2892 37.5096 57.1562 36.4219 57.1562H26.5781C25.4904 57.1562 24.6094 56.2892 24.6094 55.2188V52.3125C24.6094 50.1716 26.3714 48.4375 28.5469 48.4375H34.4531C36.6286 48.4375 38.3906 50.1716 38.3906 52.3125Z",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.5 48.4375C33.6746 48.4375 35.4375 46.7026 35.4375 44.5625C35.4375 42.4224 33.6746 40.6875 31.5 40.6875C29.3254 40.6875 27.5625 42.4224 27.5625 44.5625C27.5625 46.7026 29.3254 48.4375 31.5 48.4375Z",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M58.0781 52.3125V55.2188C58.0781 56.2892 57.1971 57.1562 56.1094 57.1562H46.2656C45.1779 57.1562 44.2969 56.2892 44.2969 55.2188V52.3125C44.2969 50.1716 46.0589 48.4375 48.2344 48.4375H54.1406C56.3161 48.4375 58.0781 50.1716 58.0781 52.3125Z",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.1875 48.4375C53.3621 48.4375 55.125 46.7026 55.125 44.5625C55.125 42.4224 53.3621 40.6875 51.1875 40.6875C49.0129 40.6875 47.25 42.4224 47.25 44.5625C47.25 46.7026 49.0129 48.4375 51.1875 48.4375Z",
					stroke: "#8043FF",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_14030_19441",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 63,
				height: 62,
				fill: "white"
			})
		}) })
	]
});
export default SvgProductAuth;
